/**
 * SaveActionBar - Action bar for saving recommendations (matches change bar styling)
 */
import React from 'react';

interface SaveActionBarProps {
  selectedCount: number;
  itemLabel: string; // e.g., "keyword", "asset"
  onSave: () => void;
  isSaving?: boolean;
  disabled?: boolean;
  className?: string;
}

export function SaveActionBar({
  selectedCount,
  itemLabel,
  onSave,
  isSaving = false,
  disabled = false,
  className = '',
}: SaveActionBarProps) {
  const isDisabled = disabled || selectedCount === 0 || isSaving;

  return (
    <div className={`mt-4 p-4 bg-blue-700 rounded-md shadow-lg ${className}`}>
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm text-white">
          <strong>{selectedCount}</strong> {itemLabel}
          {selectedCount !== 1 ? 's' : ''} selected
        </p>
        <button
          onClick={onSave}
          disabled={isDisabled}
          className={`px-4 py-2 rounded-md font-medium transition-colors w-full sm:w-auto ${
            isDisabled
              ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
              : 'bg-white text-blue-800 hover:bg-blue-50'
          }`}
        >
          {isSaving ? 'Saving...' : 'Apply to Campaign'}
        </button>
      </div>
    </div>
  );
}
